import { render, staticRenderFns } from "./MyModalExcursion.vue?vue&type=template&id=f48c8c44&"
import script from "./MyModalExcursion.vue?vue&type=script&setup=true&lang=js&"
export * from "./MyModalExcursion.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports